// extracted by mini-css-extract-plugin
module.exports = {"container":"container___1wWDP","shadowBox":"shadowBox___2JjZ6","sideBar":"sideBar___lfAtS","topBar":"topBar___3771c","content":"content___33xpZ","wrapper":"wrapper___1gkaI"};